// Original survey-drawing illustrations for service cards and gallery sheets.
const T = ({ x, y, children, s = 9, r = 0 }) => (
  <text x={x} y={y} fontSize={s} fill="currentColor" stroke="none" fontFamily="JetBrains Mono" transform={r ? `rotate(${r} ${x} ${y})` : undefined}>{children}</text>
);
const Mon = ({ x, y, gold }) => (
  <g><circle cx={x} cy={y} r="4" className={gold ? "art-gold" : ""} /><path d={`M${x - 8} ${y}h16M${x} ${y - 8}v16`} strokeWidth=".6" /></g>
);
const rnd = (seed) => { let s = seed; return () => { s = (s * 9301 + 49297) % 233280; return s / 233280; }; };
const wave = (y, a, k, ph) => `M -10 ${y} ` + Array.from({ length: 22 }, (_, i) => `L ${i * 20} ${y + Math.sin(i * k + ph) * a + Math.cos(i * 0.31 + ph) * a * 0.6}`).join(" ");

const V = {
  boundary: () => (<>
    <path d="M70 60 L300 45 L330 200 L95 220 Z" strokeWidth="1.6" />
    {[[70, 60], [300, 45], [330, 200], [95, 220]].map(([x, y], i) => <Mon key={i} x={x} y={y} gold={i === 1} />)}
    <path d="M140 105 h90 v60 h-90z" strokeDasharray="4 3" />
    <T x={150} y={42} r={-4}>N 86°15'E 230.6'</T><T x={315} y={130} r={79}>S 11°03'E 158.0'</T>
    <T x={150} y={140}>DWELLING</T><path d="M360 40v30M355 50l5-10 5 10" /><T x={355} y={84} s={8}>N</T>
  </>),
  alta: () => (<>
    <path d="M60 50 L340 50 L340 215 L60 215 Z" strokeWidth="1.6" />
    <path d="M60 180 L340 180 M60 195 L340 195" className="art-gold" strokeDasharray="6 4" />
    <rect x="110" y="75" width="110" height="70" /><path d="M110 75l110 70M220 75l-110 70" strokeWidth=".4" />
    {Array.from({ length: 6 }).map((_, i) => <path key={i} d={`M${245 + i * 14} 80v40`} strokeWidth=".7" />)}
    <T x={120} y={160}>BLDG FF 101.25</T><T x={232} y={176} s={8}>SCH B-7 EASEMENT</T><T x={246} y={135} s={8}>12 SPACES</T>
  </>),
  topo: () => (<>
    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => <path key={i} d={wave(40 + i * 25, 9 + i, 0.42, i * 0.5)} strokeWidth={i % 4 === 0 ? 1.4 : 0.7} />)}
    {[[90, 70, "104.2"], [210, 120, "101.8"], [300, 190, "98.6"]].map(([x, y, t]) => <g key={t}><path d={`M${x - 4} ${y}h8M${x} ${y - 4}v8`} className="art-gold" /><T x={x + 6} y={y - 4} s={8}>{t}</T></g>)}
  </>),
  contour: () => (<>
    {Array.from({ length: 8 }).map((_, i) => <ellipse key={i} cx={200 + i * 3} cy={130 - i * 2} rx={30 + i * 22} ry={18 + i * 13} transform={`rotate(-12 200 130)`} strokeWidth={i % 4 === 0 ? 1.4 : 0.7} />)}
    <circle cx="203" cy="128" r="3" className="art-gold" /><T x={210} y={124}>112.0</T><T x={318} y={200} s={8}>100</T>
  </>),
  asbuilt: () => (<>
    <rect x="80" y="60" width="140" height="100" strokeWidth="1.6" /><rect x="220" y="90" width="70" height="70" strokeWidth="1.6" />
    <path d="M40 200 H360 M40 214 H360" /><path d="M80 180 h210" className="art-gold" /><path d="M80 175v10M290 175v10" className="art-gold" />
    <T x={160} y={196} s={8} >210.00'</T><T x={95} y={110}>AS-BUILT</T><T x={95} y={124} s={8}>FF 101.32 (D 101.30)</T>
  </>),
  construction: () => (<>
    <rect x="110" y="60" width="180" height="120" strokeDasharray="6 4" />
    {[[110, 60], [290, 60], [290, 180], [110, 180], [200, 60], [200, 180]].map(([x, y], i) => <g key={i}><path d={`M${x - 6} ${y - 6}l12 12M${x + 6} ${y - 6}l-12 12`} className="art-gold" /><path d={`M${x} ${y}l${x < 200 ? -30 : 30} ${y < 100 ? -20 : 20}`} strokeDasharray="2 3" /></g>)}
    <T x={40} y={36} s={8}>OS 10' C 1.25</T><T x={300} y={222} s={8}>OS 10' F 0.40</T><T x={165} y={124}>STAKE PLAN</T>
  </>),
  route: () => (<>
    <path d="M-10 200 C 100 190, 160 90, 250 80 S 380 60, 420 40" strokeWidth="2" />
    <path d="M-10 225 C 100 215, 170 115, 255 105 S 380 85, 420 65" /><path d="M-10 175 C 100 165, 150 65, 245 55 S 380 35, 420 15" />
    {[0, 1, 2, 3, 4].map((i) => <g key={i}><circle cx={40 + i * 80} cy={[196, 160, 86, 72, 50][i]} r="3" className="art-gold" /><T x={30 + i * 80} y={[186, 150, 76, 62, 40][i] + 40} s={8}>{`${i + 1}+00`}</T></g>)}
    <T x={20} y={30} s={8}>ROW 66'</T>
  </>),
  utility: () => (<>
    <path d="M20 70 H380" strokeWidth="1.4" /><path d="M20 120 H380" strokeDasharray="10 4 2 4" /><path d="M20 170 H380" className="art-gold" strokeDasharray="8 6" /><path d="M20 210 H380" strokeDasharray="2 4" />
    {[90, 220, 330].map((x) => <g key={x}><circle cx={x} cy={70} r="8" /><path d={`M${x - 5} 65l10 10M${x + 5} 65l-10 10`} strokeWidth=".6" /></g>)}
    <T x={24} y={62} s={8}>8" SAN</T><T x={24} y={112} s={8}>12" W</T><T x={24} y={162} s={8}>4" GAS</T><T x={24} y={202} s={8}>UG TEL (QL-B)</T><T x={232} y={92} s={8}>INV 96.42</T>
  </>),
  drainage: () => (<>
    <path d="M60 60 L200 120 L340 90 M200 120 L220 220" strokeWidth="1.4" />
    {[[60, 60], [200, 120], [340, 90], [220, 220]].map(([x, y], i) => <rect key={i} x={x - 8} y={y - 8} width="16" height="16" />)}
    {[[130, 90, 24], [270, 105, -12], [210, 170, 80]].map(([x, y, r], i) => <path key={i} d="M-6 -4 L6 0 L-6 4" className="art-gold" transform={`translate(${x} ${y}) rotate(${r})`} />)}
    <T x={210} y={140} s={8}>MH-2 IL 94.10</T><T x={70} y={50} s={8}>CB-1</T>
  </>),
  subdivision: () => (<>
    <path d="M30 140 C 120 120, 260 120, 380 150" strokeWidth="2" /><path d="M30 165 C 120 145, 260 145, 380 175" strokeWidth="2" />
    {[0, 1, 2, 3, 4].map((i) => <g key={i}><path d={`M${50 + i * 66} ${133 - (i === 2 ? 4 : 0)} V40`} /><T x={66 + i * 66} y={90}>{`${i + 1}`}</T></g>)}
    {[0, 1, 2, 3, 4].map((i) => <g key={`b${i}`}><path d={`M${50 + i * 66} ${160} V240`} /><T x={66 + i * 66} y={210}>{`${i + 6}`}</T></g>)}
    <path d="M50 40 H380" /><path d="M50 240 H380" /><T x={250} y={160} s={8} >ELM CT</T>
  </>),
  elevation: () => (<>
    <path d="M20 190 C 90 170, 140 150, 200 160 S 320 120, 380 130" strokeWidth="1.4" />
    <rect x="150" y="90" width="110" height="68" />
    {[[150, 90, "TOB 104.8"], [260, 158, "LAG 100.6"], [205, 158, "FF 101.2"]].map(([x, y, t]) => <g key={t}><path d={`M${x} ${y}v-26`} /><path d={`M${x - 6} ${y - 26}h12l-6 8z`} className="art-gold" /><T x={x + 6} y={y - 30} s={8}>{t}</T></g>)}
    <path d="M20 215 H380" strokeDasharray="3 5" />
  </>),
  tree: () => {
    const r = rnd(7);
    return (<>{Array.from({ length: 11 }).map((_, i) => { const x = 40 + r() * 320, y = 40 + r() * 170, s = 12 + r() * 18; return <g key={i}><circle cx={x} cy={y} r={s} strokeDasharray="3 2" /><circle cx={x} cy={y} r="2.5" className="art-gold" /><T x={x + 4} y={y - 4} s={7}>{`T${101 + i}`}</T></g>; })}</>);
  },
  hydro: () => {
    const r = rnd(3);
    return (<>
      <path d="M0 40 C 80 60, 140 30, 220 50 S 360 40, 400 60" strokeWidth="1.8" />
      {[0, 1, 2].map((i) => <path key={i} d={`M0 ${90 + i * 45} C 90 ${110 + i * 45}, 150 ${75 + i * 45}, 230 ${100 + i * 45} S 360 ${90 + i * 45}, 400 ${110 + i * 45}`} strokeDasharray="5 4" />)}
      {Array.from({ length: 14 }).map((_, i) => <T key={i} x={20 + r() * 360} y={80 + r() * 150} s={7}>{(2 + r() * 9).toFixed(1)}</T>)}
    </>);
  },
  volume: () => (<>
    {Array.from({ length: 6 }).map((_, i) => <path key={i} d={`M${200 - (110 - i * 18)} 140 Q 200 ${140 - (90 - i * 14)} ${200 + (120 - i * 19)} 140 Q 200 ${150 + (40 - i * 7)} ${200 - (110 - i * 18)} 140`} strokeWidth={i === 0 ? 1.4 : 0.7} />)}
    <path d="M40 230 L120 230 Q 200 170 280 230 L360 230" className="art-gold" /><T x={150} y={250} s={8}>V = 4,215 CY (DEMO)</T>
  </>),
  drone: () => (<>
    {[0, 1, 2].map((r) => [0, 1, 2, 3].map((c) => <rect key={`${r}${c}`} x={40 + c * 75} y={30 + r * 62} width="100" height="76" strokeWidth=".6" opacity=".7" />))}
    <path d="M60 50 H360 V125 H60 V200 H360" className="art-gold" strokeDasharray="5 4" />
    <g transform="translate(360 50)"><circle r="5" /><path d="M-12 -12l24 24M12 -12l-24 24" /><circle cx="-12" cy="-12" r="4" /><circle cx="12" cy="12" r="4" /><circle cx="12" cy="-12" r="4" /><circle cx="-12" cy="12" r="4" /></g>
    <T x={44} y={250} s={8}>GSD 2.1 cm · ORTHO TILE GRID</T>
  </>),
  pointcloud: () => {
    const r = rnd(11);
    return (<>
      {Array.from({ length: 240 }).map((_, i) => { const x = r() * 400, y = 150 + Math.sin(x / 50) * 30 + (r() - 0.5) * 40; return <circle key={i} cx={x} cy={y} r=".9" fill="currentColor" stroke="none" opacity={0.4 + r() * 0.6} />; })}
      <path d={Array.from({ length: 21 }, (_, i) => `${i ? "L" : "M"} ${i * 20} ${150 + Math.sin((i * 20) / 50) * 30}`).join(" ")} className="art-gold" strokeWidth="1.6" />
      <T x={20} y={40} s={8}>LAS → BREAKLINE EXTRACT</T>
    </>);
  },
  gis: () => (<>
    {[0, 1, 2].map((i) => <path key={i} d={`M120 ${70 + i * 50} L240 ${40 + i * 50} L340 ${80 + i * 50} L220 ${110 + i * 50} Z`} className={i === 1 ? "art-gold" : ""} strokeWidth={i === 1 ? 1.4 : 0.8} />)}
    <T x={40} y={80} s={8}>PARCELS</T><T x={40} y={130} s={8}>UTILITIES</T><T x={40} y={180} s={8}>TOPOGRAPHY</T>
  </>),
  conversion: () => (<>
    {["1,5021.33,2210.84,101.2,IP", "2,5088.10,2302.15,100.8,IP", "3,5010.47,2380.62,99.6,CM", "4,4950.02,2275.91,100.1,IP"].map((l, i) => <T key={i} x={20} y={70 + i * 22} s={8}>{l}</T>)}
    <path d="M190 120 h30 M212 112 l8 8 -8 8" className="art-gold" />
    <path d="M250 70 L360 60 L370 180 L262 190 Z" strokeWidth="1.6" />
    {[[250, 70], [360, 60], [370, 180], [262, 190]].map(([x, y], i) => <Mon key={i} x={x} y={y} />)}
  </>),
};

export const ART_KEYS = Object.keys(V);

export const Art = ({ kind = "boundary", tone = "dark", className = "" }) => {
  const stroke = tone === "dark" ? "#8EC3EE" : "#102A43";
  return (
    <svg viewBox="0 0 400 260" className={className} fill="none" stroke={stroke} strokeWidth="1" color={stroke} role="img" aria-label={`${kind} survey drawing illustration`}>
      <style>{`.art-gold{stroke:${tone === "dark" ? "#D8B66A" : "#1769AA"}}`}</style>
      {(V[kind] || V.boundary)()}
    </svg>
  );
};
